import { FormTypes } from './form.types';

export const addValidationField = formFieldData => {
  return {
    "type": FormTypes.ADD_VALIDATION_FIELD,
    "payload": formFieldData
  };
};

export const removeValidationField = formFieldData => {
  return {
    "type": FormTypes.REMOVE_VALIDATION_FIELD,
    "payload": formFieldData
  };
};

export const addDependentsToIgnoreList = inputNames => {
  return {
    "type": FormTypes.ADD_DEPENDENT_FIELDS,
    "payload": inputNames
  };
};

export const removeDependentsFromIgnoreList = inputNames => {
  return {
    "type": FormTypes.REMOVE_DEPENDENT_FIELDS,
    "payload": inputNames
  };
};

export const addPreventFormSubmissionField = config => {
  return {
    "type": FormTypes.ADD_PREVENT_FORM_SUBMISSION_FIELD,
    "payload": config
  };
};

export const removePreventFormSubmissionField = config => {
  return {
    "type": FormTypes.REMOVE_PREVENT_FORM_SUBMISSION_FIELD,
    "payload": config
  };
};